import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Avatar } from '../Avatar';

type Props = {
  iconNames?: IconProp[];
  iconClasses?: string;
  pictureUrl?: string;
  title?: string;
  description?: string;
  moreDescription?: string;
  classes?: string;
};

const SimpleWidgetCard = (props: Props): JSX.Element => {
  const { iconNames = [], iconClasses, pictureUrl, title, description, moreDescription, classes } = props;

  return (
    <div className={`px-4 place-content-center rounded-2xl border-2 border-transparent group w-full h-full bg-neutral-100 ${classes ?? ''}`}>
      <div className='block mb-3 mt-4'>
        {iconNames && iconNames.map((iconName, index) => (
          <FontAwesomeIcon icon={iconName} className={`${iconClasses ?? ''} mr-1 text-2xl`} key={`${iconName}-${index}`} /> // eslint-disable-line react/no-array-index-key
        ))}
        {pictureUrl && (
          <Avatar imageUrl={pictureUrl} size={38} />
        )}
      </div>
      {title && (
        <div className='mt-1 font-bold text-base'>
          {title}
        </div>
      )}
      <div className='block text-xs mt-2 mb-3'>
        {description && (
          <div>
            { description }
          </div>
        )}
        {moreDescription && (
          <div className='mt-2 font-bold'>
            { moreDescription }
          </div>
        )}
      </div>
    </div>
  );
};

export { SimpleWidgetCard };
